import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

const Placeholder = ({ title }) => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        {title}
      </h2>
      <p className="glass-panel__body glass-panel__body--muted" data-testid="section-body">
        Copy in preparation.
      </p>
      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
      </div>
    </SectionLayout>
  );
};

export default Placeholder;
